module.exports = global["surveylab_page_checkboxFree"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./checkbox-free.ts");